import Image from 'next/image';
import Link from 'next/link';
import styles from './styles.module.scss';

const OfferBox = props => {
    const {promoCopy, promoImage, promoCta, colorScheme} = props || {};

    const renderImage = () => {
        const {mediaItemUrl, mediaDetails, altText} = promoImage?.node || {};
        if(!mediaItemUrl) return null;
        return(
            <div className={styles.resourceHero__offerImage}>
                <Image src={mediaItemUrl} width={mediaDetails?.width} height={mediaDetails?.height} alt={altText || "Promo"}/>
            </div>
        );
    }
    
    const renderCopy = () => {
        if(!promoCopy) return null;
        return (
            <div  className={`${styles.resourceHero__offerCopy}  ${colorScheme && colorScheme[0]} `} dangerouslySetInnerHTML={{__html: promoCopy}}/>
        );
    }

    const renderCta = () => {
        const {url, title} = promoCta || {};
        return(
            <div>
                <Link href={url || `#`} className={`${styles.resourceHero__offerCta} ${colorScheme && colorScheme[0]} button small`}>
                    {title}
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.0013 2.66663L7.0613 3.60663L10.7813 7.33329H2.66797V8.66663H10.7813L7.0613 12.3933L8.0013 13.3333L13.3346 7.99996L8.0013 2.66663Z" fill="#78250F"/>
                    </svg>
                </Link>
            </div>  
        );
    }
    return (
        <div className={styles.resourceHero__offer}>
            <div className={styles.resourceHero__offerInner}>
                {renderImage()}
                <div>
                    {renderCopy()}
                    {renderCta()}
                </div>
            </div>
        </div>        
    );
}

export default OfferBox;